import React from 'react';
import { BrandTurn, TURN_LABEL } from '../../utils/brand-turn';

/** Nhãn nhỏ "Đến lượt bạn" (cam) / "Chờ đối tác" (xám) cạnh trạng thái đơn. */
const TurnPill: React.FC<{ turn: BrandTurn | null }> = ({ turn }) => {
  if (!turn) return null;
  const cls =
    turn === 'mine'
      ? 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300'
      : 'bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-300';
  return <span className={`rounded-full px-2 py-0.5 text-[12px] font-semibold ${cls}`}>{TURN_LABEL[turn]}</span>;
};

export default TurnPill;
